// extracted by mini-css-extract-plugin
module.exports = {"icon":"SvgIcon_icon__X2rP3","fill":"SvgIcon_fill__KDJJ1","stroke":"SvgIcon_stroke__LZBi_"};